import React, { useRef, useEffect } from 'react';
import { FaBold, FaItalic, FaUnderline, FaListUl, FaListOl, FaLink, FaEraser } from 'react-icons/fa';
import './RichTextEditor.css';

const RichTextEditor = ({ value, onChange, placeholder }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

  const execCommand = (command, val = null) => {
    document.execCommand(command, false, val);
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const addLink = () => {
    const url = prompt('Enter the URL');
    if (url) execCommand('createLink', url);
  };

  return (
    <div className="rich-text-editor-container">
      <div className="rte-toolbar">
        <select onChange={(e) => execCommand('formatBlock', e.target.value)} defaultValue="">
          <option value="" disabled>Headings</option>
          <option value="<h1>">H1</option>
          <option value="<h2>">H2</option>
          <option value="<h3>">H3</option>
          <option value="<h4>">H4</option>
          <option value="<h5>">H5</option>
          <option value="<h6>">H6</option>
          <option value="<p>">Normal</option>
        </select>

        <div className="toolbar-group">
          <button type="button" onClick={() => execCommand('bold')} title="Bold"><FaBold /></button>
          <button type="button" onClick={() => execCommand('italic')} title="Italic"><FaItalic /></button>
          <button type="button" onClick={() => execCommand('underline')} title="Underline"><FaUnderline /></button>
        </div>

        <div className="toolbar-group">
          <button type="button" onClick={() => execCommand('insertUnorderedList')} title="Bullet Points"><FaListUl /></button>
          <button type="button" onClick={() => execCommand('insertOrderedList')} title="Numbered List"><FaListOl /></button>
        </div>

        <div className="toolbar-group">
          <button type="button" onClick={addLink} title="Hyperlink"><FaLink /></button>
          <button type="button" onClick={() => execCommand('removeFormat')} title="Clear Formatting"><FaEraser /></button>
        </div>
      </div>
      
      <div
        ref={editorRef}
        className="rte-content"
        contentEditable
        onInput={handleInput}
        placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;
